/* ============================================================
   GOLDEN STAR JEWELLERY — SMOOTH SCROLL TO #gsj-reviews
   File: assets/gsj-reviews-anchor.js

   Used by the star-rating link on the standard product page and
   by the badge injected into the Nivoda panel. Both point at
   #gsj-reviews.

   Why this exists rather than reusing the theme's Lenis layer:
   snippets/gsj-smooth-scroll.liquid is scoped to
   'cash_for_gold_only', so Lenis is not loaded on product or
   Nivoda pages. Turning it on sitewide would be a much larger
   behavioural change than this task calls for.

   Why not `html { scroll-behavior: smooth }`: that would alter
   every in-page anchor on every template.

   So: a delegated listener bound to this document, matching only
   our own [data-gsj-reviews-link] / #gsj-nivoda-badge elements.
   No global scroll or resize handlers, no rAF loop. The sticky
   header offset comes from CSS scroll-margin-top on the target,
   which scrollIntoView honours natively.

   Degrades cleanly: with JS off or on error the links are still
   ordinary in-page anchors that jump to the right section.
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR = '[data-gsj-reviews-link], #gsj-nivoda-badge';
  var TARGET_ID = 'gsj-reviews';

  function prefersReducedMotion() {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function onClick(event) {
    try {
      var link = event.target && event.target.closest ? event.target.closest(SELECTOR) : null;
      if (!link) return;

      var target = document.getElementById(TARGET_ID);
      if (!target) return;              /* no target on this page — let the browser do whatever it would */

      event.preventDefault();
      target.scrollIntoView({
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start'
      });

      /* Move focus so keyboard and screen-reader users land there too.
         preventScroll stops the focus call fighting the smooth scroll. */
      if (typeof target.focus === 'function') {
        try { target.focus({ preventScroll: true }); } catch (e) { /* older browsers */ }
      }

      if (window.history && typeof window.history.replaceState === 'function') {
        try { window.history.replaceState(null, '', '#' + TARGET_ID); } catch (e) { /* ignore */ }
      }
    } catch (e) {
      /* never surface — the anchor still works without us */
    }
  }

  try {
    document.addEventListener('click', onClick);
  } catch (e) { /* never surface */ }
})();
